var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:(_vm.avatarStyle)},[(_vm.url)?_c('img',{staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.url,"alt":""}}):_c('img',{attrs:{"src":require("../assets/images/default_avatar.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }